import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from "react";
import { DECIMAL_SEPARATOR, THOUNSAND_SEPARATOR, } from "./constants";
import { toCurrency } from "./utils";
import InputTextField from "../TextField/InputTextField";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { conformToMask } from "react-text-mask";
const currencyMask = createNumberMask({
    prefix: 'R$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: THOUNSAND_SEPARATOR,
    allowDecimal: true,
    decimalSymbol: DECIMAL_SEPARATOR,
    decimalLimit: 2,
    integerLimit: 8,
    allowNegative: false,
    allowLeadingZeroes: true,
});
const maskNumberValue = (numberValue) => {
    if (numberValue !== undefined) {
        const valueWithSeparator = numberValue.toFixed(2).replace(/\./g, DECIMAL_SEPARATOR);
        const { conformedValue } = conformToMask(toCurrency(valueWithSeparator, DECIMAL_SEPARATOR), currencyMask);
        return conformedValue;
    }
    return maskNumberValue(0);
};
const Currency = forwardRef(({ inputLabel = 'preço', onChange = () => { }, value, initialValue, ...props }, ref) => {
    const [formattedValue, setFormattedValue] = useState(maskNumberValue(0));
    const [cursorPosition, setCursorPosition] = useState(0);
    const currencyRef = React.useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            var _a;
            (_a = currencyRef === null || currencyRef === void 0 ? void 0 : currencyRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }));
    useLayoutEffect(() => {
        if (currencyRef.current && currencyRef.current.selectionStart !== null) {
            [currencyRef.current.selectionStart, currencyRef.current.selectionEnd] = [cursorPosition, cursorPosition];
        }
    }, [cursorPosition, formattedValue]);
    const getNumberOfThousandSeparators = (value) => value.split(THOUNSAND_SEPARATOR).length - 1;
    const emitChange = (value, event) => {
        const currentValue = value
            .replace(new RegExp(`[^\\d${DECIMAL_SEPARATOR}${THOUNSAND_SEPARATOR}]`, 'g'), '.')
            .replace(new RegExp(`\\${THOUNSAND_SEPARATOR}`, 'g'), '')
            .replace(new RegExp(`\\${DECIMAL_SEPARATOR}`, 'g'), '.');
        if (value.length > 0) {
            onChange === null || onChange === void 0 ? void 0 : onChange(parseFloat(currentValue), event);
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined, event);
        }
    };
    const handleChange = (event) => {
        const val = event.target.value;
        const valueAsCurrency = toCurrency(val, DECIMAL_SEPARATOR);
        const { conformedValue } = conformToMask(valueAsCurrency, currencyMask);
        const currentCursorPosition = event.target.selectionStart || 0;
        const positionDiferrence = Math.abs(currentCursorPosition - conformedValue.length);
        setFormattedValue(conformedValue);
        if (positionDiferrence > 1 && conformedValue.length > 7 && currentCursorPosition > 2) {
            const thounsandDifference = getNumberOfThousandSeparators(conformedValue) - getNumberOfThousandSeparators(formattedValue);
            setCursorPosition(currentCursorPosition + thounsandDifference);
        }
        else {
            setCursorPosition(conformedValue.length);
        }
        emitChange(conformedValue, event);
    };
    useEffect(() => {
        setFormattedValue(maskNumberValue(value));
    }, [value]);
    useEffect(() => {
        setFormattedValue(maskNumberValue(initialValue));
    }, [initialValue]);
    return (_jsx(InputTextField, { ...props, ref: currencyRef, value: formattedValue, onChange: handleChange, "aria-label": inputLabel === null || inputLabel === void 0 ? void 0 : inputLabel.toString(), inputLabel: inputLabel }));
});
export default Currency;
//# sourceMappingURL=Currency.js.map